import { Controller } from '@hotwired/stimulus';

const CARD_SELECTOR = '[data-design-element-id]';
const BADGE_SELECTOR = '[data-design-badge]';

// Folder cards carry the badge whenever they hold a new or revised design, so a
// folder worth opening survives the filter without being special-cased here.
export default class extends Controller {
  static values = { active: Boolean };

  toggle(event) {
    this.activeValue = event.target.checked;
  }

  // Stimulus calls this on initialization too, so the grid starts in sync.
  activeValueChanged() {
    this.apply();
  }

  apply() {
    this.element.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      card.hidden = this.activeValue && !card.querySelector(BADGE_SELECTOR);
    });
  }
}
